import { useCallback } from 'react';
import useSubscriptionUpsell from '../subscriptions/useSubscriptionUpsell';
import useSubscriptionModal from '../subscriptions/useSubscriptionModal';
import { Feature } from '../../types/subscriptions';

function useMarketingActionGate() {
  const { requireUpsell, upsell, isSubscriptionActive } = useSubscriptionUpsell(
    Feature.MARKETING,
    { upsellOnMount: false },
  );
  const { openSubscriptionModal } = useSubscriptionModal();

  return useCallback(
    (action: () => void) => {
      if (!isSubscriptionActive) {
        openSubscriptionModal();
        return;
      }
      if (requireUpsell) {
        upsell();
        return;
      }
      action();
    },
    [isSubscriptionActive, openSubscriptionModal, requireUpsell, upsell],
  );
}

export default useMarketingActionGate;
